<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9"
      cy="9"
      r="8.25"
      stroke="#4C00FF"
      stroke-width="1.5"
    />
    <path
      d="M13.0964 5.87305C12.6016 5.87305 11.8557 6.38515 11.2315 6.89725C10.417 7.5675 9.72437 8.36577 9.19155 9.26948C8.78812 9.94726 8.40754 10.7757 8.40754 11.4459M8.39992 11.4461C8.39992 11.0846 8.18679 10.6253 7.96605 10.2562C7.6692 9.7592 7.28861 9.32241 6.84712 8.96093C6.5046 8.67475 6.10117 8.39611 5.82715 8.39611"
      stroke="#4D00FF"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
</template>
